module.exports = __webpack_public_path__ + "static/media/partner-logo6.16389f83.png";